import React from 'react';
import { TypedMemo } from '../../../common/types';
import { useMusicVideoEditor } from '../../MusicVideoEditorContext';
import { AiClipForm } from './AiClipForm';
import { AiClipList } from './AiClipList';
import { AiLockedCard } from './AiLockedCard';
import { useAiClip } from './useAiClip';

/**
 * The AI tab (design h1, h2, h4): the form of a new clip and the list of the AI clips of this song.
 * Free and the trial get the lock card (`plan.canMakeAiFootage`, spec D10); a 403 shows it too.
 */
const AiTabComponent: React.FC = () => {
  const { data } = useMusicVideoEditor();
  const ai = useAiClip();
  if (!data.plan.canMakeAiFootage || ai.error === 'plan') {
    return <AiLockedCard credits={data.plan.aiClipCredits} />;
  }
  return (
    <>
      <AiClipForm make={ai.make} isBusy={ai.isBusy} error={ai.error} />
      <AiClipList />
    </>
  );
};

export const AiTab = TypedMemo(AiTabComponent);
